import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useConnect } from '@lore/query-connect';
import User from '@/pages/people-partners/User';
import mapResponse from '@/utils/mapResponse';

OfferUser.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  offer: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired
};

export default function OfferUser(props) {
  const { user, offer } = props;

  const claims = useConnect('claim.find', {
    where: {
      eager: {
        $where: {
          offerId: offer.id,
          request: { $not: 'Outreach' }
        }
      }
    },
    pagination: {
      pageSize: 1000
    }
  });

  const claim = _.find(claims.data, function(claim) {
    return claim.data.userId === user.id;
  });

  const selected = !!claim;

  return (
    <User
      user={user}
      offer={offer}
      selected={selected}
      footer={claim ? mapResponse(claim.data.response) : undefined}
    />
  );
}
